import client from './client';

export const getTemplates = (params = {}) =>
  client.get('/document-templates', { params });

export const getTemplate = (id) =>
  client.get(`/document-templates/${id}`);

export const createTemplate = (data) =>
  client.post('/document-templates', data);

export const updateTemplate = (id, data) =>
  client.put(`/document-templates/${id}`, data);

export const deleteTemplate = (id) =>
  client.delete(`/document-templates/${id}`);

export const duplicateTemplate = (id) =>
  client.post(`/document-templates/${id}/duplicate`);

export const getAvailableFields = (recordTypeId) =>
  client.get(`/document-templates/available-fields/${recordTypeId}`);

export const aiMapPlaceholders = (data) =>
  client.post('/document-templates/ai-map', data);

export const generateDocument = (templateId, recordId) =>
  client.post(`/document-templates/${templateId}/generate/${recordId}`);

export const downloadDocx = (templateId, recordId, data = {}) =>
  client.post(`/document-templates/${templateId}/generate/${recordId}/docx`, data, {
    responseType: 'blob'
  });

export const saveDocument = (templateId, recordId, data) =>
  client.post(`/document-templates/${templateId}/generate/${recordId}/save`, data);

export const emailDocument = (templateId, recordId, data) =>
  client.post(`/document-templates/${templateId}/generate/${recordId}/email`, data);

// DOCX template operations
export const uploadDocxTemplate = (formData) =>
  client.post('/document-templates/upload-docx', formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const reuploadDocx = (id, formData) =>
  client.put(`/document-templates/${id}/reupload-docx`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' }
  });

export const downloadOriginalDocx = (id) =>
  client.get(`/document-templates/${id}/download-docx`, { responseType: 'blob' });

// DOCX preview & save from preview
export const saveDocxToRecord = (templateId, data) =>
  client.post(`/document-templates/${templateId}/save-docx`, data);

// DOCX placeholder matching
export const matchDocxFields = (data) =>
  client.post('/document-templates/match-docx-fields', data);

// Batch operations
export const batchEmailDocuments = (data) =>
  client.post('/document-templates/batch/email', data);
export const batchDownloadDocuments = (data) =>
  client.post('/document-templates/batch/download', data, { responseType: 'blob' });

// Template tags
export const getTemplateTags = (q = '') =>
  client.get('/document-templates/tags/autocomplete', { params: { q } });

export const updateTemplateTags = (id, tags) =>
  client.patch(`/document-templates/${id}/tags`, { tags });
